import React, { useState } from 'react'
import type { CityService, ServiceGroup } from 'src/store/data.store'
import type { SelectedService } from 'src/store/appointment.store'
import { ServicesListItem } from './ServicesListItem'

type ServiceGroupListItemProps = {
  group: ServiceGroup,
  /** The group's option that is in the booking, if any */
  selected?: SelectedService<CityService>,
  isButtonDisabled: boolean,
  salonId?: number | null,
  onServiceSelect: (serviceId: number, amount: number) => void,
  onServiceAmountChange: (serviceId: number, amount: number) => void,
  onServiceReplace: (serviceId: number, newServiceId: number, amount: number) => void,
}

/**
 * A service page in the booking list. Its options are a choice: picking another option of a selected
 * page swaps the booked service, otherwise it only changes what the button will add.
 */
export const ServiceGroupListItem: React.FC<ServiceGroupListItemProps> = (props) => {
  const { group, selected, isButtonDisabled, salonId, onServiceSelect, onServiceAmountChange, onServiceReplace } = props
  const [chosenIdx, setChosenIdx] = useState(0)
  const selectedIdx = selected ? group.options.findIndex((option) => option.service.id === selected.id) : -1
  const activeIdx = selectedIdx !== -1 ? selectedIdx : Math.min(chosenIdx, group.options.length - 1)
  const service = group.options[activeIdx].service

  const handleOptionChange = (idx: number) => {
    setChosenIdx(idx)
    if (selected && idx !== selectedIdx) {
      onServiceReplace(selected.id, group.options[idx].service.id, selected.amount)
    }
  }

  return (
    <ServicesListItem
      service={selected ?? service}
      options={group.options}
      activeOptionIdx={activeIdx}
      onOptionChange={handleOptionChange}
      isButtonDisabled={isButtonDisabled}
      isButtonSecondary={!!selected}
      buttonTitle={selected ? 'Отменить' : 'Выбрать'}
      isSelected={!!selected}
      onButtonClick={(amount) => onServiceSelect(service.id, amount)}
      onAmountChange={(amount) => onServiceAmountChange(service.id, amount)}
      isAmountChangeable={!!service.isAmountChangeable}
      salonId={salonId}
    />
  )
}
